// src/forms/add-board-content/add-article/published-article/ArticleComments.jsx
import { useEffect,useState } from 'react';

import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text  from '@/shared-components/text/components/Text';

import CommentForm from '../../shared-components/board-comments/CommentForm';
import CommentList from '../../shared-components/board-comments/CommentList';

import './ArticleComments.css';

export default function ArticleComments({ articleId, initialReplyTo, onCommentAdded }) {
  const [replyTo, setReplyTo] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // when we mount or initialReplyTo changes, set it
  useEffect(() => {
    if (initialReplyTo) {
      setReplyTo(initialReplyTo);
    }
  }, [initialReplyTo]);

  const handleNew = () => {
    setReplyTo(null);
    setRefreshKey(k => k + 1);
    onCommentAdded();
  };

  return (
    <div className="article-comments-container">
      <div className="article-comments-list">
        <CommentList
          key={refreshKey}
          resourceType="post"
          resourceId={articleId}
          onReply={c => setReplyTo(c)}
        />
      </div>
      <div className="article-comments-form">
        {replyTo && (
          <div className="article-comments-reply-status">
            <Text className="article-comments-reply-text font-size-small">
              Replying to <span>{replyTo.commenter.user_username}</span>
            </Text>
            <XIcon
              className="article-comments-reply-close"
              onClick={() => setReplyTo(null)}
            />
          </div>
        )}

        <CommentForm
          resourceType="post"
          resourceId={articleId}
          parentId={
            replyTo
              ? (replyTo.comment_parent ?? replyTo._id)
              : null
          }
          replyToUser={replyTo?.commenter.user_username}
          onNewComment={handleNew}
        />
      </div>
    </div>
  );
}